import React, { useEffect, useRef, useState } from "react";

import { combineClasses } from "@kikoff/utils/src/string";

import { MessageBubble, MessageBubbleProps } from "@component/cards";

import styles from "./tooltips.module.scss";

interface InfoTooltipProps extends Partial<MessageBubbleProps> {
  prompt?: React.ReactNode;
  title?: React.ReactNode | true;
  message?: React.ReactNode;
  className?: string;
  leftOffset?: string;
}
/**
 * @deprecated use Tooltip instead
 */
export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  prompt,
  title,
  message,
  className,
  leftOffset = "20px",
  ...props
}) => {
  const [show, setShow] = useState(false);
  const [width, setWidth] = useState(null);
  const bubbleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const rect = bubbleRef.current.getBoundingClientRect();
    setWidth(window.innerWidth - rect.left - 20);
    function click(e) {
      if (show) {
        e.preventDefault();
        e.stopPropagation();
        setShow(false);
      }
    }
    document.addEventListener("click", click, true);
    return () => {
      document.removeEventListener("click", click, true);
    };
  }, [show]);

  return (
    <div
      className={combineClasses(
        styles["info-tooltip"],
        "info-tooltip",
        className
      )}
    >
      <header
        onClick={() => {
          setShow(true);
        }}
      >
         <span className={styles.prompt}>{prompt}</span>
      </header>
      <div
        className={styles.content}
        style={{
          opacity: show ? 1 : 0,
          pointerEvents: show ? "auto" : "none",
          transform: `translate(-${leftOffset}, 10px)`,
          width,
        }}
      >
        <MessageBubble
          ref={bubbleRef}
          pointerSize={10}
          side="top"
          offset={{ left: `calc(${leftOffset} + 0.5em - 4px)` }}
          className={styles["tooltip-message"]}
          {...props}
        >
          {title && (
            <header className={styles.title}>
              {title === true ? prompt : title}
            </header>
          )}
          {message}
        </MessageBubble>
      </div>
    </div>
  );
};
